import bg1all from "../assets/images/imgComunities/allBg1.svg";
import homeleft from "../assets/images/btmhomeleft.svg";
import homeright from "../assets/images/btmhomeright.svg";

import iconNwdc from "../assets/images/imgComunities/Nwdc/Icon.svg";
import logoNwdc from "../assets/images/imgComunities/Nwdc/Logo.svg";
import projectNwdc from "../assets/images/imgComunities/Nwdc/Project.svg";
import bg2Nwdc from "../assets/images/imgComunities/Nwdc/Bg2.svg";
import bg3Nwdc from "../assets/images/imgComunities/Nwdc/Bg3.svg";
import pvpNwdc from "../assets/images/imgComunities/Nwdc/Pvp.svg";
import photoPNwdc from "../assets/images/imgComunities/Nwdc/PhotoP.svg";
import photoVpNwdc from "../assets/images/imgComunities/Nwdc/PhotoVp.svg";
import or1Nwdc from "../assets/images/imgComunities/Nwdc/Orn1.svg";
import or2Nwdc from "../assets/images/imgComunities/Nwdc/Orn2.svg";

import iconNuxc from "../assets/images/imgComunities/Nuxc/Icon.svg";
import logoNuxc from "../assets/images/imgComunities/Nuxc/Logo.svg";
import projectNuxc from "../assets/images/imgComunities/Nuxc/Project.svg";
import bg2Nuxc from "../assets/images/imgComunities/Nuxc/Bg2.svg";
import bg3Nuxc from "../assets/images/imgComunities/Nuxc/Bg3.svg";
import pvpNuxc from "../assets/images/imgComunities/Nuxc/Pvp.svg";
import photoPNuxc from "../assets/images/imgComunities/Nuxc/PhotoP.svg";
import photoVpNuxc from "../assets/images/imgComunities/Nuxc/PhotoVp.svg";
import or1Nuxc from "../assets/images/imgComunities/Nuxc/Orn1.svg";
import or2Nuxc from "../assets/images/imgComunities/Nuxc/Orn2.svg";

import iconNcpc from "../assets/images/imgComunities/Ncpc/Icon.svg";
import logoNcpc from "../assets/images/imgComunities/Ncpc/Logo.svg";
import projectNcpc from "../assets/images/imgComunities/Ncpc/Project.svg";
import bg2Ncpc from "../assets/images/imgComunities/Ncpc/Bg2.svg";
import bg3Ncpc from "../assets/images/imgComunities/Ncpc/Bg3.svg";
import pvpNcpc from "../assets/images/imgComunities/Ncpc/Pvp.svg";
import photoPNcpc from "../assets/images/imgComunities/Ncpc/PhotoP.svg";
import photoVpNcpc from "../assets/images/imgComunities/Ncpc/PhotoVp.svg";
import or1Ncpc from "../assets/images/imgComunities/Ncpc/Orn1.svg";
import or2Ncpc from "../assets/images/imgComunities/Ncpc/Orn2.svg";

import iconNlnc from "../assets/images/imgComunities/Nlnc/Icon.svg";
import logoNlnc from "../assets/images/imgComunities/Nlnc/Logo.svg";
import projectNlnc from "../assets/images/imgComunities/Nlnc/Project.svg";
import bg2Nlnc from "../assets/images/imgComunities/Nlnc/Bg2.svg";
import bg3Nlnc from "../assets/images/imgComunities/Nlnc/Bg3.svg";
import pvpNlnc from "../assets/images/imgComunities/Nlnc/Pvp.svg";
import photoPNlnc from "../assets/images/imgComunities/Nlnc/PhotoP.svg";
import photoVpNlnc from "../assets/images/imgComunities/Nlnc/PhotoVp.svg";
import or1Nlnc from "../assets/images/imgComunities/Nlnc/Orn1.svg";
import or2Nlnc from "../assets/images/imgComunities/Nlnc/Orn2.svg";

import iconNddc from "../assets/images/imgComunities/Nddc/Icon.svg";
import logoNddc from "../assets/images/imgComunities/Nddc/Logo.svg";
import projectNddc from "../assets/images/imgComunities/Nddc/Project.svg";
import bg2Nddc from "../assets/images/imgComunities/Nddc/Bg2.svg";
import bg3Nddc from "../assets/images/imgComunities/Nddc/Bg3.svg";
import pvpNddc from "../assets/images/imgComunities/Nddc/Pvp.svg";
import photoPNddc from "../assets/images/imgComunities/Nddc/PhotoP.svg";
import photoVpNddc from "../assets/images/imgComunities/Nddc/PhotoVp.svg";
import or1Nddc from "../assets/images/imgComunities/Nddc/Orn1.svg";
import or2Nddc from "../assets/images/imgComunities/Nddc/Orn2.svg";

import iconNadc from "../assets/images/imgComunities/Nadc/Icon.svg";
import logoNadc from "../assets/images/imgComunities/Nadc/Logo.svg";
import projectNadc from "../assets/images/imgComunities/Nadc/Project.svg";
import bg2Nadc from "../assets/images/imgComunities/Nadc/Bg2.svg";
import bg3Nadc from "../assets/images/imgComunities/Nadc/Bg3.svg";
import pvpNadc from "../assets/images/imgComunities/Nadc/Pvp.svg";
import photoPNadc from "../assets/images/imgComunities/Nadc/PhotoP.svg";
import photoVpNadc from "../assets/images/imgComunities/Nadc/PhotoVp.svg";
import or1Nadc from "../assets/images/imgComunities/Nadc/Orn1.svg";
import or2Nadc from "../assets/images/imgComunities/Nadc/Orn2.svg";

const data = [
  {
    id: 1,
    path: "NWDC",
    title: "NIGHT LOGIN WEB \nDEVELOPMENT COMMUNITY",
    desc: "NWDC (Nightlogin Web Development Community) merupakan komunitas bagi mahasiswa yang memiliki ketertarikan kepada web, baik itu web development maupun web design.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNwdc,
    logo: logoNwdc,
    project: projectNwdc,
    pvp: pvpNwdc,
    bg2: bg2Nwdc,
    bg3: bg3Nwdc,
    photoP: photoPNwdc,
    photoVp: photoVpNwdc,
    or1: or1Nwdc,
    or2: or2Nwdc,
  },
  {
    id: 2,
    path: "NUXC",
    title: "NIGHT LOGIN USER \nEXPERIENCE COMMUNITY",
    desc: "Komunias NUXC (Night Login User Experience Community) merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti user experience.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNuxc,
    logo: logoNuxc,
    project: projectNuxc,
    pvp: pvpNuxc,
    bg2: bg2Nuxc,
    bg3: bg3Nuxc,
    photoP: photoPNuxc,
    photoVp: photoVpNuxc,
    or1: or1Nuxc,
    or2: or2Nuxc,
  },
  {
    id: 3,
    path: "NCPC",
    title: "NIGHT LOGIN COMPETITIVE \nPROGRAMMING COMMUNITY",
    desc: "NCPC (Nightlogin Competitive Programming Community) merupakan komunitas bagi mahasiswa yang memiliki ketertarikan kepada competitive programming.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNcpc,
    logo: logoNcpc,
    project: projectNcpc,
    pvp: pvpNcpc,
    bg2: bg2Ncpc,
    bg3: bg3Ncpc,
    photoP: photoPNcpc,
    photoVp: photoVpNcpc,
    or1: or1Ncpc,
    or2: or2Ncpc,
  },
  {
    id: 4,
    path: "NLNC",
    title: "NIGHT LOGIN LINUX AND \nNETWORKING COMMUNITY",
    desc: "NLNC (Nightlogin Linux and Networking Community) merupakan komunitas bagi mahasiswa yang tertarik pada Linux dan Jaringan, seperti keamanan jaringan, dll.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNlnc,
    logo: logoNlnc,
    project: projectNlnc,
    pvp: pvpNlnc,
    bg2: bg2Nlnc,
    bg3: bg3Nlnc,
    photoP: photoPNlnc,
    photoVp: photoVpNlnc,
    or1: or1Nlnc,
    or2: or2Nlnc,
  },
  {
    id: 5,
    path: "NDDC",
    title: "NIGHT LOGIN DATA SCIENCE AND \nDATA ANALYTIC COMMUNITY",
    desc: "Komunitas NDDC (Nightlogin Data Science and Data Analytic Community)  merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti data dan analytics.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNddc,
    logo: logoNddc,
    project: projectNddc,
    pvp: pvpNddc,
    bg2: bg2Nddc,
    bg3: bg3Nddc,
    photoP: photoPNddc,
    photoVp: photoVpNddc,
    or1: or1Nddc,
    or2: or2Nddc,
  },
  {
    id: 6,
    path: "NADC",
    title: "NIGHT LOGIN APLICATION \nDEVELOPMENT COMMUNITY",
    desc: "Komunitas NDDC (Nightlogin Data Science and Data Analytic Community)  merupakan komunitas bagi mahasiswa yang menyenangi ataupun ingin menggeluti data dan analytics.",
    pName: "KIM MINJI",
    vpName: "KIM MINJI",
    bg1: bg1all,
    btmleft: homeleft,
    btmright: homeright,
    icon: iconNadc,
    logo: logoNadc,
    project: projectNadc,
    pvp: pvpNadc,
    bg2: bg2Nadc,
    bg3: bg3Nadc,
    photoP: photoPNadc,
    photoVp: photoVpNadc,
    or1: or1Nadc,
    or2: or2Nadc,
  },
];

export default data;
